import { ABMGenerico } from "src/general_components/ABMGenerico";

export const Modulos = () => {
    const modelo = "modulos";

    return (
        <>
            <ABMGenerico modelo={modelo} titulo={"Modulos"}  />
            
        </>
    );
};
